import { Locale } from 'modules/i18n';

export const headerTranslation = {
  [Locale.en]: {
    title: 'Charging model',
  },
};
